import {CarouselItemStyles} from "./types"

const carouselItemStyleDefault: CarouselItemStyles = {
  itemStyles: {
    height: 200,
    cursor: "pointer",
  },
  headerStyles: {
    boxStyle: {},
    textStyle: {
      color: "#595958",
      fontFamily: "Open Sans",
      fontSize: 14,
      fontWeight: 400,
    },
  },
  contentStyle: {
    boxStyle: {},
    imageStyle: {
      borderRadius: 3.9,
    },
  },
  footerStyle: {
    boxStyle: {},
    textStyle: {
      color: "#6a6a69",
      fontFamily: "Open Sans",
      fontSize: 14,
      fontWeight: 400,
      textDecoration: "none",
      marginTop: "7.7px",
    },
  },
}

export default carouselItemStyleDefault
